import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import AddMrvFormLocal from "./AddMrvFormLocal";
import Swal from 'sweetalert2';

const LocalOrders = ({ onSuccess }) => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState();
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [mrv, setMrv] = useState([]);
  const [selectedMrv, setSelectedMrv] = useState([]);
  const [run, setRun] = useState(0);

  const [items, setItems] = useState([
    {
      name: "",
      id: "",
      description: "",
      approveQty: 0,
      qtyRequired: 0,

      recivedQty: "",

      damageQty: 0,

      // GST / Bill Amounts
      cgstAmountAtReceipt: "",
      sgstAmountAtReceipt: "",
      igstAmountAtReceipt: "",
      amountWithGSTAtReceipt: "",

      error: "",
      gstError: "",

      unit: ""
    },
  ]);
  const [partOptions, setPartOptions] = useState([]);

  const handleAddItem = (e) => {
    e.preventDefault();

    const lastItem =
      items[items.length - 1];

    if (
      !lastItem ||
      !lastItem.id ||
      !lastItem.name ||
      Number(lastItem.recivedQty) <= 0 ||
      Number(lastItem.recivedQty) !==
      Number(lastItem.approveQty)
    ) {

      Swal.fire({
        icon: "warning",
        title: "Incomplete Item",
        text:
          "Please select the item and enter Received Qty equal to Approved Qty before adding a new item.",
        confirmButtonText: "OK"
      });

      return;
    }

    setItems([
      ...items,
      {
        name: "",
        id: "",
        description: "",
        approveQty: 0,
        qtyRequired: 0,

        recivedQty: "",

        damageQty: 0,

        cgstAmountAtReceipt: "",
        sgstAmountAtReceipt: "",
        igstAmountAtReceipt: "",
        amountWithGSTAtReceipt: "",

        error: "",
        gstError: "",

        unit: ""
      }
    ]);
  };

  const handleItemChange = (
    index,
    field,
    value
  ) => {

    const newItems = [...items];

    // ======================================
    // DAMAGE ALWAYS ZERO
    // ======================================
    if (field === "damageQty") {

      newItems[index].damageQty = 0;

      setItems(newItems);

      return;
    }

    // ======================================
    // NUMERIC OPTIONAL FIELDS
    // Keep blank as blank
    // ======================================
    const numericFields = [
      "recivedQty",
      "cgstAmountAtReceipt",
      "sgstAmountAtReceipt",
      "igstAmountAtReceipt",
      "amountWithGSTAtReceipt"
    ];

    const numericValue =
      numericFields.includes(field)
        ? value === ""
          ? ""
          : Number(value)
        : value;

    newItems[index][field] =
      numericValue;

    // ======================================
    // RECEIVED QTY VALIDATION
    // ======================================
    if (field === "recivedQty") {

      const approveQty =
        Number(
          newItems[index].approveQty || 0
        );

      newItems[index].damageQty = 0;

      if (numericValue === "") {

        newItems[index].error =
          "Received Qty is required.";

      } else if (
        !Number.isFinite(
          Number(numericValue)
        )
      ) {

        newItems[index].error =
          "Received Qty must be a valid number.";

      } else if (
        Number(numericValue) <= 0
      ) {

        newItems[index].error =
          "Received Qty must be greater than 0.";

      } else if (
        Number(numericValue) !== approveQty
      ) {

        newItems[index].error =
          `Received Qty must be equal to Approved Qty (${approveQty}). Partial receipt is not allowed.`;

      } else {

        newItems[index].error = "";

      }
    }

    // ======================================
    // GST AMOUNT VALIDATION
    // OPTIONAL FIELDS
    //
    // ALLOWED:
    // CGST + SGST (must be equal)
    // OR
    // IGST
    // ======================================
    const gstFields = [
      "cgstAmountAtReceipt",
      "sgstAmountAtReceipt",
      "igstAmountAtReceipt"
    ];

    if (gstFields.includes(field)) {

      const cgst =
        Number(
          newItems[index]
            .cgstAmountAtReceipt || 0
        );

      const sgst =
        Number(
          newItems[index]
            .sgstAmountAtReceipt || 0
        );

      const igst =
        Number(
          newItems[index]
            .igstAmountAtReceipt || 0
        );

      newItems[index].gstError = "";

      // No negative GST
      if (
        cgst < 0 ||
        sgst < 0 ||
        igst < 0
      ) {

        newItems[index].gstError =
          "GST amount cannot be negative.";

      }

      // IGST cannot be with CGST / SGST
      else if (
        igst > 0 &&
        (cgst > 0 || sgst > 0)
      ) {

        newItems[index].gstError =
          "Enter either IGST or CGST/SGST, not both.";

      }

      // CGST and SGST must both be entered
      else if (
        (cgst > 0 && sgst <= 0) ||
        (sgst > 0 && cgst <= 0)
      ) {

        newItems[index].gstError =
          "CGST and SGST must both be entered.";

      }

      // CGST and SGST must be equal
      else if (
        cgst > 0 &&
        sgst > 0 &&
        cgst !== sgst
      ) {

        newItems[index].gstError =
          "CGST and SGST amounts must be equal.";

      }
    }

    setItems(newItems);
  };

  const handlePartSelect = (index, selectedOption) => {
    const isDuplicate = items.some(item => item.id === selectedOption.value);
    if (isDuplicate) {
      Swal.fire({ icon: 'error', title: 'Duplicate Item', text: 'This item has already been added.', confirmButtonText: 'OK' });
      return;
    }
    handleItemChange(index, "id", selectedOption.value);
    handleItemChange(index, "name", selectedOption.label);
    handleItemChange(index, "approveQty", selectedOption.approveQty);
    handleItemChange(index, "qtyRequired", selectedOption.qtyRequired);
    handleItemChange(index, "description", selectedOption.description);
    handleItemChange(index, "unit", selectedOption.unit);
  };

  const handleRemoveItem = (e, index) => {
    e.preventDefault();
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };

  useEffect(() => {
    if (selectedStore) {
      setItems([
        {
          name: "",
          id: "",
          description: "",
          approveQty: 0,
          qtyRequired: 0,

          recivedQty: "",

          damageQty: 0,

          cgstAmountAtReceipt: "",
          sgstAmountAtReceipt: "",
          igstAmountAtReceipt: "",
          amountWithGSTAtReceipt: "",

          error: "",
          gstError: "",

          unit: ""
        }
      ]);

      RequestServies.getMrv(selectedStore)
        .then((res) => {
          const filteredMrvs = res?.data?.data?.filter(m => {
            // ✅ Include only MRVs with supplier starting with "local"
            return m.supplier && m.supplier?.name?.toLowerCase().startsWith("local");
          });

          setMrv(filteredMrvs);
          setSelectedMrv(filteredMrvs[0]?._id || "");
        })
        .catch(console.log);
    }
  }, [selectedStore, run]);




  useEffect(() => {
    if (!selectedStore) return;
    const status = 'local';
    const poStatus = 'generated';
    RequestServies.getAllItem(undefined, status, selectedStore, poStatus)
      .then((res) => {
        const options = res?.data?.data?.map((part) => ({
          value: part?._id,
          label: `${part?.inventory?.masterItem?.partNo} | ${part?.inventory?.masterItem?.description}`,
          approveQty: part?.approveQty,
          description: part?.inventory?.masterItem?.description,
          qtyRequired: part?.qtyRequired,
          unit: part?.inventory?.masterItem?.unit?.name,
        }));
        setPartOptions(options);
      })
      .catch(console.log);
  }, [selectedStore, selectedMrv, run]);

  const handleSubmit = (e) => {
    e.preventDefault();

    let isValid = true;
    let errorMessage = "";

    // ======================================
    // VALIDATE ITEMS
    // LOCAL MRV:
    // 1. Damage Qty = 0
    // 2. No partial receipt
    // 3. Received Qty must equal Approved Qty
    // 4. GST amount fields are optional
    // 5. CGST + SGST must be equal
    // 6. Use either IGST OR CGST/SGST
    // ======================================

    for (let index = 0; index < items.length; index++) {

      const item = items[index];

      const receivedQty =
        Number(item.recivedQty);

      const approveQty =
        Number(item.approveQty);

      const cgstAmount =
        Number(
          item.cgstAmountAtReceipt || 0
        );

      const sgstAmount =
        Number(
          item.sgstAmountAtReceipt || 0
        );

      const igstAmount =
        Number(
          item.igstAmountAtReceipt || 0
        );

      const amountWithGST =
        Number(
          item.amountWithGSTAtReceipt || 0
        );

      // ======================================
      // ITEM REQUIRED
      // ======================================
      if (!item.id) {

        isValid = false;

        errorMessage =
          `Item ${index + 1}: Please select an item.`;

        break;
      }

      // ======================================
      // RECEIVED QTY REQUIRED
      // ======================================
      if (
        item.recivedQty === "" ||
        item.recivedQty === undefined ||
        item.recivedQty === null ||
        !Number.isFinite(receivedQty)
      ) {

        isValid = false;

        errorMessage =
          `Item ${index + 1}: Please enter a valid Received Qty.`;

        break;
      }

      // ======================================
      // RECEIVED QTY MUST BE GREATER THAN 0
      // ======================================
      if (
        receivedQty <= 0
      ) {

        isValid = false;

        errorMessage =
          `Item ${index + 1}: Received Qty must be greater than 0.`;

        break;
      }

      // ======================================
      // NO PARTIAL RECEIPT
      // RECEIVED MUST EQUAL APPROVED
      // ======================================
      if (
        receivedQty !== approveQty
      ) {

        isValid = false;

        errorMessage =
          `Item ${index + 1}: Received Qty (${receivedQty}) must be equal to Approved Qty (${approveQty}). Partial receipt is not allowed.`;

        break;
      }

      // ======================================
      // OPTIONAL GST VALUES
      // MUST BE VALID NUMBERS
      // ======================================
      if (
        !Number.isFinite(cgstAmount) ||
        !Number.isFinite(sgstAmount) ||
        !Number.isFinite(igstAmount) ||
        !Number.isFinite(amountWithGST)
      ) {

        isValid = false;

        errorMessage =
          `Item ${index + 1}: Please enter valid GST amounts.`;

        break;
      }

      // ======================================
      // NEGATIVE GST NOT ALLOWED
      // ======================================
      if (
        cgstAmount < 0 ||
        sgstAmount < 0 ||
        igstAmount < 0 ||
        amountWithGST < 0
      ) {

        isValid = false;

        errorMessage =
          `Item ${index + 1}: GST amounts cannot be negative.`;

        break;
      }

      // ======================================
      // IGST CANNOT BE USED WITH CGST / SGST
      // ======================================
      if (
        igstAmount > 0 &&
        (
          cgstAmount > 0 ||
          sgstAmount > 0
        )
      ) {

        isValid = false;

        errorMessage =
          `Item ${index + 1}: Enter either IGST or CGST/SGST, not both.`;

        break;
      }

      // ======================================
      // CGST & SGST MUST BOTH BE ENTERED
      // ======================================
      if (
        (
          cgstAmount > 0 &&
          sgstAmount <= 0
        ) ||
        (
          sgstAmount > 0 &&
          cgstAmount <= 0
        )
      ) {

        isValid = false;

        errorMessage =
          `Item ${index + 1}: CGST and SGST must both be entered.`;

        break;
      }

      // ======================================
      // CGST & SGST MUST BE EQUAL
      // ======================================
      if (
        cgstAmount > 0 &&
        sgstAmount > 0 &&
        cgstAmount !== sgstAmount
      ) {

        isValid = false;

        errorMessage =
          `Item ${index + 1}: CGST and SGST amounts must be equal.`;

        break;
      }

      // ======================================
      // MRV REQUIRED
      // ======================================
      if (!selectedMrv) {

        isValid = false;

        errorMessage =
          "MRV Not Selected!";

        break;
      }
    }

    // ======================================
    // SHOW VALIDATION ERROR
    // ======================================
    if (!isValid) {

      Swal.fire({
        title: "Error!",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // PREPARE REQUEST
    //
    // GST FIELDS ARE OPTIONAL.
    // BLANK VALUES WILL GO AS 0.
    // DAMAGE IS ALWAYS 0.
    // ======================================
    const requestItems = items.map(
      (item) => ({
        ...item,

        recivedQty:
          Number(
            item.recivedQty
          ),

        approveQty:
          Number(
            item.approveQty || 0
          ),

        qtyRequired:
          Number(
            item.qtyRequired || 0
          ),

        // ======================================
        // DAMAGE ALWAYS ZERO
        // ======================================
        damageQty: 0,

        // ======================================
        // OPTIONAL GST / BILL AMOUNTS
        // ======================================
        cgstAmountAtReceipt:
          Number(
            item.cgstAmountAtReceipt || 0
          ),

        sgstAmountAtReceipt:
          Number(
            item.sgstAmountAtReceipt || 0
          ),

        igstAmountAtReceipt:
          Number(
            item.igstAmountAtReceipt || 0
          ),

        amountWithGSTAtReceipt:
          Number(
            item.amountWithGSTAtReceipt || 0
          ),
      })
    );

    const requestData = {
      mrvId: selectedMrv,
      items: requestItems,
    };

    console.log(
      "Local MRV Request:",
      requestData
    );

    // ======================================
    // SUBMIT LOCAL MRV
    // ======================================
    RequestServies
      .localsubmitMrv(
        requestData
      )
      .then(() => {

        Swal.fire({
          title: "Success!",
          text: "Order received successfully",
          icon: "success",
          confirmButtonText: "OK",
        });

        // ======================================
        // RESET FORM
        // ======================================
        setItems([
          {
            name: "",
            id: "",
            description: "",
            approveQty: 0,
            qtyRequired: 0,

            recivedQty: "",

            damageQty: 0,

            // GST / Bill amounts
            cgstAmountAtReceipt: "",
            sgstAmountAtReceipt: "",
            igstAmountAtReceipt: "",
            amountWithGSTAtReceipt: "",

            error: "",
            gstError: "",

            unit: "",
          },
        ]);

        setRun(
          (previous) =>
            previous + 1
        );
      })
      .catch((error) => {

        console.error(
          "Local MRV submission error:",
          error
        );

        Swal.fire({
          title: "Error!",
          text:
            error?.response?.data?.message ||
            "Error during submission",
          icon: "error",
          confirmButtonText: "Retry",
        });
      });
  };


  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    setSelectedMrv();
  };
  const handleRequisitionForm = () => setIsModelOpen(true);
  const handleMrv = (e) => {
    setSelectedMrv(
      e.target.value
    );

    setItems([
      {
        name: "",
        id: "",
        description: "",
        approveQty: 0,
        qtyRequired: 0,

        recivedQty: "",

        damageQty: 0,

        cgstAmountAtReceipt: "",
        sgstAmountAtReceipt: "",
        igstAmountAtReceipt: "",
        amountWithGSTAtReceipt: "",

        error: "",
        gstError: "",

        unit: ""
      }
    ]);

    setPartOptions([]);
  };
  useEffect(() => setPartOptions([]), [selectedMrv]);

  return (
    <>
      <AddMrvFormLocal show={isModelOpen} handleClose={() => setIsModelOpen(false)} store={stores} onSuccess={() => setRun(prev => prev + 1)} />
      <div className="row">
        <div className="col-xl-12">
          {/* Filter Section */}
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa"><i className="fas fa-filter me-2"></i>Filter</div>
              <div className="tools"><Link to="#" className={`SlideToolHeader ${open ? "collapse" : "expand"}`} onClick={() => setOpen(!open)}><i className="fas fa-angle-up"></i></Link></div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4 col-xxl-4">
                      <label>Select Store</label>

                      <Select
                        options={stores.map((store) => ({
                          value: store._id,
                          label: store.name,
                        }))}
                        value={
                          stores
                            .map((store) => ({
                              value: store._id,
                              label: store.name,
                            }))
                            .find((opt) => opt.value === selectedStore) || null
                        }
                        onChange={(selected) =>
                          handleStoreChange({
                            target: {
                              value: selected ? selected.value : "",
                            },
                          })
                        }
                        placeholder="Search Store..."
                        isSearchable
                        className="mb-xl-0 mb-3"
                      />
                    </div>
                    <div className="col-xl-4 col-xxl-4">
                      <label>Select MRV No.</label>

                      <Select
                        options={
                          mrv.length > 0
                            ? mrv.map((m) => ({
                              value: m._id,
                              label: m.mrvNo,
                            }))
                            : []
                        }
                        value={
                          mrv
                            .map((m) => ({
                              value: m._id,
                              label: m.mrvNo,
                            }))
                            .find((opt) => opt.value === selectedMrv) || null
                        }
                        onChange={(selected) =>
                          handleMrv({
                            target: {
                              value: selected ? selected.value : "",
                            },
                          })
                        }
                        placeholder={
                          mrv.length > 0 ? "Search MRV No..." : "No records found"
                        }
                        noOptionsMessage={() => "No records found"}
                        isSearchable
                        className="mb-xl-0 mb-3"
                      />
                    </div>
                    <div className="col-xl-4 col-xxl-4">
                      <button className="btn btn-sm btn-primary mt-4 w-100" onClick={handleRequisitionForm}>Generate New MRV No</button>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>

          {/* Add Item Section */}
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa"><i className="fa fa-plus me-2" aria-hidden="true"></i>Add MRV Item</div>
              <div className="tools"><Link to="#" className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`} onClick={() => setOpen2(!open2)}><i className="fas fa-angle-up"></i></Link></div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <form>
                      {items.map((item, index) => (
                        <div key={index} className="row">
                          <div className="form-group mb-2 col-md-3">
                            <label>Part Number</label>
                            <Select options={partOptions} onChange={(selectedOption) => handlePartSelect(index, selectedOption)} placeholder="Part" menuPortalTarget={document.body} styles={{ control: (base) => ({ ...base, minWidth: 90, height: 14, fontSize: '12px' }) }} />
                          </div>
                          <div className="form-group mb-2 col-md-3">
                            <label>Description</label>
                            <input type="text" className="form-control form-control-sm" value={item.description} readOnly />
                          </div>
                          <div className="form-group mb-2 col-md-2">
                            <label>Approved ({item.unit || ''})</label>
                            <input type="number" className="form-control form-control-sm" value={item.approveQty} readOnly />
                          </div>
                          <div className="form-group mb-2 col-md-2">
                            <label>Required ({item.unit || ''})</label>
                            <input type="number" className="form-control form-control-sm" value={item.qtyRequired} readOnly />
                          </div>
                          <div className="form-group mb-2 col-md-2">
                            <label>Received ({item.unit || ''})</label>
                            <input type="number" className="form-control form-control-sm" value={item.recivedQty} onChange={(e) => handleItemChange(index, "recivedQty", e.target.value)} />
                            <p className="text-danger">{item.error}</p>
                          </div>
                          {/* ======================================
    OPTIONAL GST / BILL AMOUNTS
====================================== */}

                          <div className="form-group mb-2 col-md-2">
                            <label>CGST Amount</label>

                            <input
                              type="number"
                              min="0"
                              step="any"
                              className="form-control form-control-sm"
                              value={
                                item.cgstAmountAtReceipt ?? ""
                              }
                              placeholder="Optional"
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "cgstAmountAtReceipt",
                                  e.target.value
                                )
                              }
                            />
                          </div>


                          <div className="form-group mb-2 col-md-2">
                            <label>SGST Amount</label>

                            <input
                              type="number"
                              min="0"
                              step="any"
                              className="form-control form-control-sm"
                              value={
                                item.sgstAmountAtReceipt ?? ""
                              }
                              placeholder="Optional"
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "sgstAmountAtReceipt",
                                  e.target.value
                                )
                              }
                            />
                          </div>


                          <div className="form-group mb-2 col-md-2">
                            <label>IGST Amount</label>

                            <input
                              type="number"
                              min="0"
                              step="any"
                              className="form-control form-control-sm"
                              value={
                                item.igstAmountAtReceipt ?? ""
                              }
                              placeholder="Optional"
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "igstAmountAtReceipt",
                                  e.target.value
                                )
                              }
                            />
                          </div>


                          <div className="form-group mb-2 col-md-2">
                            <label>Amount With GST</label>

                            <input
                              type="number"
                              min="0"
                              step="any"
                              className="form-control form-control-sm"
                              value={
                                item.amountWithGSTAtReceipt ?? ""
                              }
                              placeholder="Optional"
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "amountWithGSTAtReceipt",
                                  e.target.value
                                )
                              }
                            />
                          </div>


                          {/* GST VALIDATION MESSAGE */}
                          {item.gstError && (
                            <div className="col-md-12 mb-2">
                              <small className="text-danger">
                                {item.gstError}
                              </small>
                            </div>
                          )}

                          <div className="form-group mb-2 col-md-2">
                            <label>
                              Damage ({item.unit || ''})
                            </label>

                            <input
                              type="number"
                              className="form-control form-control-sm"
                              value={0}
                              readOnly
                              disabled
                              tabIndex={-1}
                            />

                            <small className="text-muted">
                              Damage quantity is currently disabled
                            </small>
                          </div>
                          <div className="form-group mb-1 col-md-1">
                            <button className="btn btn-danger btn-xs sharp mt-1" onClick={(e) => handleRemoveItem(e, index)}><i className="fa fa-trash"></i></button>
                          </div>
                        </div>
                      ))}
                      <div className="row mt-2">
                        <div className="col-md-2"><button className="btn btn-sm btn-primary" onClick={handleAddItem}>Add Item</button></div>
                        <div className="col-md-2"><button className="btn btn-sm btn-primary" onClick={handleSubmit}>Submit</button></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default LocalOrders;
